import { render, staticRenderFns } from "./PerfildeUsuario.vue?vue&type=template&id=4c13e8a4&scoped=true&"
import script from "./PerfildeUsuario.vue?vue&type=script&lang=ts&"
export * from "./PerfildeUsuario.vue?vue&type=script&lang=ts&"
import style0 from "./PerfildeUsuario.vue?vue&type=style&index=0&id=4c13e8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13e8a4",
  null
  
)

export default component.exports